'use strict';

module.exports = function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/dom-helpers/style/removeStyle.js
// module id = 1397
// module chunks = 0